import React, { useState, useEffect } from "react";
import { Link,useNavigate  } from "react-router-dom";
import "./cart.css";
import { getCartItems, setCartItems, clearCartItems } from "../../util/Cart";
import toast from "react-hot-toast";

function Cart() {
  const [cartItems, setCartItemsState] = useState([]);
  const navigate = useNavigate(); 


  useEffect(() => {
    const items = getCartItems();
    setCartItemsState(items);
  }, []);

  const handleRemove = (itemId) => {
    const updatedItems = cartItems.filter(
      (item) => item.product._id !== itemId
    );
    setCartItemsState(updatedItems);
    setCartItems(updatedItems);
  };

  const handleClear = () => {
    setCartItemsState([]);
    clearCartItems();
  };

  const handleCheckout = () => {
    // Check if there are items in the cart
    if (cartItems.length === 0) {
        toast.error("Please add products to the cart before checking out!");
        return;
    }
    
    // Check for user data to see if the user is logged in
    const userData = localStorage.getItem('userData');
    if (!userData) {
        // If user is not logged in, save the intended checkout path
        localStorage.setItem('lastPath', '/checkout/cart');
        // Redirect user to login page
        navigate('/login');
        return;
    }

    // If user is logged in and cart has items, navigate to the checkout page
    navigate("/checkout/cart");
};


  const handleQuantityChange = (itemId, delta) => {
    const updatedItems = cartItems
      .map((item) => {
        if (item.product._id === itemId) {
          return { ...item, quantity: item.quantity + delta };
        }
        return item;
      })
      .filter((item) => item.quantity > 0); // Remove items with quantity 0
    setCartItemsState(updatedItems);
    setCartItems(updatedItems);
  };

  const totalVariantPrice = cartItems.reduce(
    (total, item) => total + item.product.variantPrice * item.quantity,
    0
  );

  const totalCompareAtPrice = cartItems.reduce(
    (total, item) => total + (item.product.variantCompareAtPrice || 0) * item.quantity,
    0
  );

  const totalSavings = totalCompareAtPrice - totalVariantPrice;

  return (
    <div className="cart">
      <div className="cart-left">
        <h1>Your cart</h1>
        {cartItems.length === 0 ? (
          <p className="no-cart">No items in the cart</p>
        ) : (
          <ul>
            {cartItems.map((item) => (
              <li key={item.product._id}>
                <Link to={`/product/${item.product._id}`}>
                  <img
                    className="cart-image"
                    src={item.product.imageSrc[0]}
                    alt={item.product.imageAltText[0] || "Product"}
                  />
                </Link>

                <div className="cart-details">
                  <Link to={`/product/${item.product._id}`}>
                    <h2>{item.product.title}</h2>
                    {item.options && item.options.length > 0 && (
                      <div className="all-options">
                        {item.options.map((option, index) => (
                          <span key={index}>{option}</span>
                        ))}
                      </div>
                    )}
                  </Link>
                  <div className="card-details-1">
                    <div className="cart-price">
                    <span> Rs {item.product.variantPrice} </span>
                    {item.product.variantCompareAtPrice && (
                      <span>
                        Rs {item.product.variantCompareAtPrice}
                      </span>
                    )}
                    </div>
                   
                    <div className="cart-quantity">
                      <button
                        className="quantity-btn btn1"
                        onClick={() =>
                          handleQuantityChange(item.product._id, -1)
                        }
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        className="quantity-btn btn1"
                        onClick={() =>
                          handleQuantityChange(item.product._id, 1)
                        }
                      >
                        +
                      </button>
                      <button
                        className="quantity-btn btn2"
                        onClick={() => handleRemove(item.product._id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="cart-right">
        <h1>Total</h1>
        <p>
          Rs{" "}
          {totalVariantPrice} <span> Rs{" "}
          {totalCompareAtPrice}</span>
        </p>
        <p>
          Total Savings: Rs{" "}
          {totalSavings}
        </p>
        <div className='btn-card'>
        <button onClick={handleCheckout}>Order Now</button>
        <button onClick={handleClear}>Clear Cart</button>
      </div>
      </div>
    </div>
  );
}

export default Cart;